<div class="modal">
    <img src="assets/linkeding_png_purple.png" alt="success-message" class="img-logo">
    <div class="modal-content">
        <p class="title_modal">{{ 'candidateProfilingSuccess.modalLinkedin.title' | translate }}</p>
        <p class="subtitle_modal">{{ 'candidateProfilingSuccess.modalLinkedin.subtitle' | translate }}</p>
        <p class="text_modal">{{ 'candidateProfilingSuccess.modalLinkedin.description' | translate }}</p>
        <div class="linkedin-follow" #linkedinFollow></div>  
    </div>
<div class="close-modal-btn"  (click)="onClose()">&times;</div>
</div>